import React from 'react';
import { RoutePath } from 'types/enums';
import { EcgAnalyzeScreen, Patients, RegisterAdminScreen, RequestsScreen } from 'screens';

const ADMIN_ROUTES = [
  { path: RoutePath.PATIENTS, element: <Patients /> },
  { path: RoutePath.ECG_ANALYZE, element: <EcgAnalyzeScreen /> },
  { path: RoutePath.REQUESTS, element: <RequestsScreen /> },
  { path: RoutePath.ADMIN, element: <RegisterAdminScreen /> },
];

export { ADMIN_ROUTES };
